export default __webpack_public_path__ + "static/media/cladding31.315f4dec.jpeg";